<div>
  <form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <!-- Podvrsta dokumenta -->
          <div class="col-md-5">       
            <div class="form-group row">
              <div class="col-md-12 col-12">
                  <!-- <yt-fw-dropdown
                  [ModelName]="'podvrstadokumentastavka'" 
                  [GetName]="'GetByUrl'"
                  [ModelProperty]="'Sifra,Naziv'" 
                  [GetParameters] = "modelData.MainList.GetParameters"
                  formControlName="PodVrstaDokumentaStavkaID" 
                  #focusElement
                  [Type]="ID"
                  [Label]="'FINDOKUMENT.PODVRSTADOKUMENTASTAVKA.SINGULAR'"
                  #autofocus
                  [ngClass]="{'is-invalid': submitted && fc.PodVrstaDokumentaStavkaID.invalid}"
                  (OnItemSelected)='onPodVrstaSelect()'>
                </yt-fw-dropdown> -->
                <yt-dropdown-picklist 
                [ModelName]="'podvrstadokumentastavka'" 
                [GetName]="'GetByUrl'" 
                [ModelProperty]="'Sifra,Naziv'"
                [GetParameters]="modelData.MainList.GetParameters" 
                formControlName="PodVrstaDokumentaStavkaID"                                  
                [Label]="'FAKDOKUMENT.PODVRSTADOKUMENTASTAVKA.SINGULAR'"                   
                [ngClass]="{'is-invalid': submitted && fc.PodVrstaDokumentaStavkaID.invalid}"
                (OnItemSelected)='onPodVrstaSelect()'
                [Width]="'600px'"
                #autofocus>
              </yt-dropdown-picklist >
                <div 
                  class="form-error" 
                  *ngIf="submitted && fc.PodVrstaDokumentaStavkaID.invalid">
                  <span *ngFor="let validation of errorMessages.PodVrstaDokumentaStavkaID">
                    <span 
                      class="error-message" 
                      *ngIf="fc.PodVrstaDokumentaStavkaID.hasError(validation.type)">
                    <span translate="{{validation.message}}"></span>
                    </span>
                </span>
              </div>
              </div>
            </div> 
          </div>
           <!-- Datum dokumenta -->
           <div class="col-md-3 col-12">
            <div class="form-group row">
              <div class="col-md-12">
                <yt-fw-date-picker-popup
                    formControlName="Datum"
                    name="txtDaNal" 
                    [Label]="'FINDOKUMENT.DATNAL.SINGULAR'"
                    [ngClass]="{'is-invalid': submitted && fc.Datum.invalid}"
                    (OnDateSelected)="onDatumChange($event)">
                </yt-fw-date-picker-popup>
                <div class="form-error" *ngIf="submitted && fc.Datum.invalid">
                    <span *ngFor="let validation of errorMessages.Datum">
                      <span class="error-message" *ngIf="fc.Datum.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                  </span>
                </div>
              </div>  
            </div>  
          </div>
          <!-- Broj dokumenta -->
          <div class="col-md-4 col-12">       
            <div class="form-group row">
              <div class="col-md-8 col-8">
                  <yt-input
                      [Type]="'text'"
                      [Label]="'FINDOKUMENT.BRNAL.SINGULAR'"
                      formControlName="Broj"
                      [ngClass]="{'is-invalid': submitted && fc.Broj.invalid}">
                  </yt-input>
                  <div class="form-error" *ngIf="submitted && fc.Broj.invalid">
                      <span *ngFor="let validation of errorMessages.Broj">
                        <span class="error-message" *ngIf="fc.Broj.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                    </span>
                  </div>
                </div>
                <div class="col-md-4 col-4">
                  <div class="input-group-append">
                    <span class="span-control">/</span><span *ngIf="baseFormGroup.get('Datum').value != null" class="span-control">{{baseFormGroup.get('Datum').value.year}}</span>
                  </div>
              </div>
            </div> 
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <yt-fin-dokument-stavka-update-container [DetailModelData]="modelData.MainList.DetailList[0]" [ParentPropertyName]="'FinDokumentID'" [ParentPropertyValue]="Item.ID"></yt-fin-dokument-stavka-update-container>
      </div>
    </div>
  </form>
</div>
